import { formatShortReference, isWordLevel, deriveWritingText } from '@skjv/common';
import { drawWritingLines } from './pdf-helpers.js';
/**
 * Writing practice section of the student page, branched on the writing
 * ladder:
 *  - NONE          → nothing (call sites skip entirely)
 *  - ONE_WORD /
 *    SEVERAL_WORDS → "Write this word/these words…" + the picked fragment
 *  - SENTENCES or
 *    legacy (no
 *    level)        → "Write this verse…" + the study's writing verse
 */
export async function renderWritingSection(doc, study, assignment, vts, startY, layout) {
    const { pageWidth, pageHeight, marginSize, padding } = layout;
    const writingLevel = assignment.student.writingLevel;
    const isWordWriting = writingLevel !== undefined && isWordLevel(writingLevel) && !!assignment.readingFragment;
    let currentY = startY + 3;
    doc.setFontSize(8);
    doc.setFont('helvetica', 'bold');
    let bodyText;
    let bodyFontSize;
    if (isWordWriting) {
        bodyText = deriveWritingText(assignment.readingFragment, writingLevel);
        const prompt = bodyText.includes(' ')
            ? 'Write these words in your best handwriting.'
            : 'Write this word in your best handwriting.';
        doc.text(prompt, marginSize + padding, currentY, { align: 'left' });
        // The picked word(s) print large — this is the whole lesson for an
        // early writer, not a caption
        bodyFontSize = 18;
    }
    else {
        doc.text('Write this verse in your best cursive or manuscript handwriting.', marginSize + padding, currentY, { align: 'left' });
        const writingVerseText = await vts.getVerseText(study.writingLocation);
        const writingVerseTitle = formatShortReference(study.writingLocation);
        bodyText = `${writingVerseText} -- ${writingVerseTitle}`;
        bodyFontSize = 12;
    }
    currentY = currentY + (isWordWriting ? 9 : 5);
    doc.setFontSize(bodyFontSize);
    doc.setFont('helvetica', isWordWriting ? 'bold' : 'normal');
    const txt = doc.splitTextToSize(bodyText, pageWidth - 2 * marginSize - 2 * padding);
    doc.text(txt, marginSize + padding, currentY, { align: 'left' });
    currentY = currentY + 6 * txt.length + 2;
    const spaceForWritingLines = pageHeight - currentY - 32;
    const numberOfWritingLines = Math.max(1, Math.floor(spaceForWritingLines / 10));
    drawWritingLines(doc, currentY, numberOfWritingLines, marginSize, padding, pageWidth);
}
//# sourceMappingURL=pdf-student-writing.js.map